__turbopack_context__.v({
  "tabs": "styles-module-scss-module__xzyfma__tabs",
});
